import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface PortfolioImage {
  id: number;
  image_url: string;
  description: string;
  service_category: string;
  is_featured: boolean;
  created_at: string;
}

// =====================================================
// 📸 PORTFOLIO COMPONENT - BeautyPortfolio.tsx
// =====================================================

const BeautyPortfolio: React.FC = () => {
  const navigate = useNavigate();
  const [images, setImages] = useState<PortfolioImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const categories = ['todos', 'Pestañas', 'Cejas', 'Uñas', 'Cabello', 'Maquillaje'];

  useEffect(() => {
    loadPortfolioImages();
  }, []);

  const loadPortfolioImages = async () => {
    // Simular carga desde API
    setTimeout(() => {
      const mockImages: PortfolioImage[] = [
        {
          id: 1,
          image_url: 'https://images.unsplash.com/photo-1583001931096-959e9a1a6223?w=400',
          description: 'Extensiones de pestañas volumen ruso',
          service_category: 'Pestañas',
          is_featured: true,
          created_at: '2025-08-15'
        },
        {
          id: 2,
          image_url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400',
          description: 'Diseño de cejas con microblading',
          service_category: 'Cejas',
          is_featured: false,
          created_at: '2025-08-14'
        },
        {
          id: 3,
          image_url: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=400',
          description: 'Nail art diseño personalizado',
          service_category: 'Uñas',
          is_featured: true,
          created_at: '2025-08-13'
        }
      ];
      setImages(mockImages);
      setLoading(false);
    }, 1000);
  };

  const filteredImages = selectedCategory === 'todos'
    ? images
    : images.filter(img => img.service_category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">📸 Mi Portfolio</h1>
              <p className="text-gray-600">Muestra tus mejores trabajos</p>
            </div>
            <div className="flex items-center space-x-4">
              <button className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-4 py-2 rounded-lg">
                ➕ Agregar Imagen
              </button>
              <button onClick={() => navigate(-1)} className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg">
                ← Volver
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Filtros */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2">
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedCategory === category
                    ? 'bg-pink-500 text-white'
                    : 'bg-white text-gray-700 hover:bg-pink-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Grid de Imágenes */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map(i => (
              <div key={i} className="bg-white rounded-xl p-4 animate-pulse">
                <div className="h-64 bg-gray-200 rounded-lg mb-4"></div>
                <div className="h-4 bg-gray-200 rounded mb-2"></div>
                <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              </div>
            ))}
          </div>
        ) : filteredImages.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredImages.map(image => (
              <div key={image.id} className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow">
                <div className="relative">
                  <img
                    src={image.image_url}
                    alt={image.description}
                    className="w-full h-64 object-cover"
                  />
                  {image.is_featured && (
                    <div className="absolute top-2 right-2 bg-yellow-400 text-yellow-900 px-2 py-1 rounded-full text-xs font-medium">
                      ⭐ Destacado
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-gray-900 mb-2">{image.description}</h3>
                  <div className="flex items-center justify-between">
                    <span className="px-2 py-1 bg-pink-100 text-pink-800 text-xs rounded-full">
                      {image.service_category}
                    </span>
                    <span className="text-xs text-gray-500">{image.created_at}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <h3 className="text-lg font-medium text-gray-900 mb-2">No hay imágenes en esta categoría</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default BeautyPortfolio;